import { baseUrl, headers, jwtHeaders } from '../common/data';

export const fetchAllProducts = async (branchId, queryParams) => {
  const response = await fetch(`${baseUrl}/api/product/getproductbybranch/${branchId}${queryParams ? queryParams : ''}`, {
    method: 'GET',
    headers: jwtHeaders(),
    redirect: 'follow',
  });
  const resData = await response?.json();

  return resData;
};

export const createProduct = async (data) => {
  let body = data;
  try {
    if (typeof data === 'string') {
      const parsed = JSON.parse(data);
      if (parsed && typeof parsed === 'object') {
        delete parsed.mrp;
        delete parsed.purchasePrice;
        body = JSON.stringify(parsed);
      }
    } else if (data && typeof data === 'object') {
      const clone = { ...data };
      delete clone.mrp;
      delete clone.purchasePrice;
      body = clone;
    }
  } catch (e) {
    // fallback if parse fails
  }

  const response = await fetch(`${baseUrl}/api/product/create`, {
    method: 'POST',
    body: data,
    body: body,
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

export const createManyProduct = async (branchId, data) => {
  const response = await fetch(`${baseUrl}/api/product/bulkUpload/${branchId}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: jwtHeaders()
  });
  const resData = await response?.json()

  return resData
};

export const updateProduct = async (id, data, branchId) => {
  let cleanData = data;
  if (data && typeof data === 'object') {
    cleanData = { ...data };
    delete cleanData.mrp;
    delete cleanData.purchasePrice;
  }

  const response = await fetch(`${baseUrl}/api/product/updateproduct/${id}${branchId ? branchId : ''}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    body: JSON.stringify(cleanData),
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;

};

// export const deleteProduct = async (id,branchId) => {

//     const response = await fetch(`${baseUrl}/api/product/deleteproduct/${id}${branchId ? branchId : ''}`, {
//       method: 'DELETE',
//       headers: jwtHeaders(),
//     });
//     const resData = await response?.json();

//     return resData;
// };

export const deleteProduct = async (id, branchId) => {
  const response = await fetch(`${baseUrl}/api/product/deleteproduct/${branchId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...jwtHeaders(),
    },
    body: JSON.stringify({
      ids: [id],
      status: false,
    })
  },
  );
  const resData = await response?.json();
  return resData;
};

// for multiple fine
export const deleteManyProduct = async ({ ids }, branchId) => {
  const response = await fetch(`${baseUrl}/api/product/deleteproduct?branchId=${branchId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...jwtHeaders(),
    },
    body: JSON.stringify({
      ids,   // This is always an array of IDs, even if there's only one
      status: false,  // Marking the product as deleted
    }),
  });

  const resData = await response?.json();
  return resData;
};


// export const deleteManyProduct = async (data, branchId) => {
//   const response = await fetch(`${baseUrl}/api/product/deletemanyproducts${branchId ? branchId : ''}`, {
//     method: 'POST',
//     body: JSON.stringify(data),
//     headers: jwtHeaders()
//   })
//   const resData = await response.json()
//   return resData
// }

// ******************************* handle Product count *************************************

export const addProductCount = async (productId, data, branchId) => {
  const response = await fetch(`${baseUrl}/api/product/addproductcount/${productId}${branchId ? `?branchId=${branchId}` : ''}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to update product count');
  }

  const resData = await response?.json();
  return resData;
};

// ******************************* handle product count *************************************

export const getProductDetails = async (productId, branchId) => {
  try {
    const response = await fetch(`${baseUrl}/api/product/getproduct/${productId}?branchId=${branchId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...jwtHeaders(),
      },
    });

    const productDetails = await response.json();
    if (response.ok) {
      return productDetails?.data;
    } else {
      console.error('Failed to fetch product details:', productDetails?.message || 'Unknown error');
      return null;
    }
  } catch (error) {
    console.error('Error fetching product details:', error);
    throw error;
  }
};
